export function getSessionCookieName(isSecure: boolean): string {
  return isSecure ? '__Secure-authjs.session-token' : 'authjs.session-token';
}

/**
 * @deprecated Use getSessionCookieName() instead. Auth.js chooses the cookie
 * name based on request security (HTTPS), not only on NODE_ENV. This constant
 * can mismatch in HTTPS dev/proxy environments.
 */
export const SESSION_COOKIE_NAME =
  process.env.NODE_ENV === 'production'
    ? '__Secure-authjs.session-token'
    : 'authjs.session-token';

export const IMPERSONATE_FLAG_COOKIE = '__pierre_impersonate';
export const RESTORE_COOKIE = '__pierre_restore';
export const IMPERSONATE_GATE_PROOF_COOKIE = '__pierre_impersonate_gate';
export const ADMIN_INFO_COOKIE = '__pierre_impersonate_admin';
export const TARGET_USER_ID_COOKIE = '__pierre_impersonate_target';
export const COOKIE_MAX_AGE = 1800; // 30 minutes
